import React, { useContext, useState } from 'react';
import { CustomersContext, ICustomersContext } from '../../../../../customersState/customersContext';
import { RequestEntity, UserRoles, IItemCustomer } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import moment from 'moment';
import Text from 'components/Text/Text';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import { DataControllerNew } from 'components/DataController/DataControllerNew';
import { ChunkOfTextWithCopyingNew } from 'components/Text/ChunkOfTextWithCopyingNew';
import { Info } from './components/Info/Info';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IProps {
	data: IItemCustomer;
	index: number;
}

export const Item: React.FC<IProps> = ({ data, index }) => {
	const { setIDForRestoring, setIDForDeletion } = useContext<ICustomersContext>(CustomersContext);
	const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false);
	const hasEditAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);
	const hasRestoreAccess = useRoleAccess([UserRoles.SUPER_USER]);
	const hasDeleteAccess = useRoleAccess([UserRoles.SUPER_USER]);

	const containerClasses = classNames(style.container, { [style.openInfo]: isOpenInfo });
	const nameRowClasses = classNames(style.row, style.name);
	const archivingDateClasses = classNames(style.row, style.archivingDate);
	const userClasses = classNames(style.row, style.user);
	const actionRowClasses = classNames(style.row, style.action);

	const handleClickInfo = () => {
		setIsOpenInfo(!isOpenInfo);
	};

	const handleSetIdForRestoring = () => {
		setIDForRestoring(data.id);
	};

	const handleSetIdForDeletion = () => {
		setIDForDeletion(data.id);
	};

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<div className={nameRowClasses}>
					<div className={style.imgWrapper}>
						<ImgUploaderByEntityId
							resource={RequestEntity.Customers}
							entityID={data.filePath ? data.id : ''}
							photoSize="Small"
							loaderSize="small"
							noImageIdIcon="customerDefaultAvatar"
						/>
					</div>
					<div className={style.customerNameWrapper}>
						<Text
							className={style.customerName}
							translationKey={data.name}
							withTooltip={true}
							isNewTooltip={true}
						/>
					</div>
					<ChunkOfTextWithCopyingNew text={data.id} className={style.copyId} />
				</div>
				<Text
					className={archivingDateClasses}
					translationKey={data.archivedDate ? moment(data.archivedDate).format('MM/DD/YYYY h:mm:ss A') : '-'}
					withTooltip={true}
					isNewTooltip={true}
				/>
				<Text
					className={userClasses}
					translationKey={data.archivedBy || '-'}
					withTooltip={true}
					isNewTooltip={true}
				/>
				<div className={actionRowClasses}>
					<DataControllerNew
						onClickInfo={handleClickInfo}
						onClickRestore={hasRestoreAccess ? handleSetIdForRestoring : undefined}
						onClickDelete={hasDeleteAccess ? handleSetIdForDeletion : undefined}
						URLWithIDToEdit={hasEditAccess ? `/clients/customers/edit?customerID=${data.id}` : undefined}
						isOpenInfo={isOpenInfo}
					/>
				</div>
			</div>
			<Info isOpenInfo={isOpenInfo} data={data} />
		</div>
	);
};
